import { useToggleModalState } from '@/shared/hooks/useToggleModalState';

import { MARKETING_MODALS } from '~/marketing/constants/modals';

export const useHostingRequestModal = () => {
  return useToggleModalState({
    name: MARKETING_MODALS.HOSTING_REQUEST,
  });
};

